/* eslint-disable @typescript-eslint/no-explicit-any */
import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  NgZone,
  Output,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'm-geo-carousel',
  templateUrl: './m-geo-carousel.component.html',
  styleUrls: ['./m-geo-carousel.component.scss']
})
export class MGeoCarouselComponent extends Carousel {
  constructor(
    el: ElementRef,
    zone: NgZone,
    cd: ChangeDetectorRef,
    renderer: Renderer2,
    @Inject(DOCUMENT) document: Document,
    @Inject(PLATFORM_ID) platformId: any,
    config: PrimeNGConfig
  ) {
    super(el, zone, cd, renderer, document, platformId, config);
  }

  @Output() navigateRequest = new EventEmitter<number>();

  onButtonClick(conversionTypeId: number): void {
    this.navigateRequest.emit(conversionTypeId);
  }
}
